import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import Login from "./component/login/login";
import Slots from "./component/slots"
import Header from "./component/header/Header";
import Notice from './component/notice/Notice';
import NoticeDetail from './component/notice/NoticeDetail';
import Users from './component/users';
import Logs from './component/logs';
import { getUserInfo } from './common/cookie';

const Layout = () => {
  return (
    <div className="vh-container">
      <Header />
      <Outlet />
    </div>
  )
}

// 로그인 상태를 확인하는 컴포넌트
const ProtectedRoute = ({ children }) => {
  const userInfo = getUserInfo();
  const isLoggedIn = userInfo && Object.keys(userInfo).length > 0;
  
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// 루트 경로에서 로그인 상태에 따라 리다이렉션하는 컴포넌트
const RootRedirect = () => {
  const userInfo = getUserInfo();
  const isLoggedIn = userInfo && Object.keys(userInfo).length > 0;
  
  if (isLoggedIn) {
    return <Navigate to="/slots" replace />;
  } else {
    return <Navigate to="/login" replace />;
  }
};

function App() {
  return (
    <Routes>
      <Route path='/' element={<RootRedirect />} />
      <Route path='/login' element={<Login />} />
      <Route path='/' element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route path='/slots' element={<Slots />} />
        <Route path='/notice' element={<Notice />} />
        <Route path='/notice/:id' element={<NoticeDetail />} />
        <Route path='/users' element={<Users />} />
        <Route path='/logs' element={<Logs />} />
      </Route>
    </Routes>
  );
}

export default App;
